<mat-expansion-panel class="w-100">
    <mat-expansion-panel-header class="w-100"
                                fxLayout="start space-between">
        <mat-panel-title class="no-wrap t2-semi-bold">
            @if (!id) {
                <div class="no-wrap t2-semi-bold">
                    {{ 'i18n_af_labelIncidentCommonDetails' | translate }}
                </div>
            }
            @if (id) {
                <div class="radius-4 bc-primary-green-100 c-primary-gray-900 pl-12 pr-12">
                    {{ 'i18n_af_labelIncidentTransactionTitle' | translate: {index: id} }}
                </div>
            }
        </mat-panel-title>

        <ui-kit-button icon="ic_download"
                       iconPosition="left"
                       type="text"
                       [isSmall]="true"
                       class="mr-16"
                       [spinnerId]="'documentsDownload_' + id || 'common'"
                       (clickListener)="downloadAllDocuments()"
                       [removePadding]="true"
                       [label]="'i18n_af_buttonDownloadAllDocuments'|translate"/>
    </mat-expansion-panel-header>
    <div fxLayout="column" fxLayoutAlign="start start" class="w-100">
        <af-file-group-preview [attachments]="attachments"/>
    </div>
</mat-expansion-panel>
